import { logNotFoundTrackingProperties } from "@b2bportal/core-tracking";
import { createSelector } from "@reduxjs/toolkit";
import { getSelectedTripDetailsAndFareDetails } from "../../store";

export type FlightSelectedTripTrackingProperties = {
  total_stops: number;
};

export const getFlightSelectedTripTrackingProperties = createSelector(
  getSelectedTripDetailsAndFareDetails,
  (selectedTripDetailsAndFareDetails): FlightSelectedTripTrackingProperties => {
    if (
      selectedTripDetailsAndFareDetails == null ||
      selectedTripDetailsAndFareDetails.tripDetails == null ||
      selectedTripDetailsAndFareDetails.tripDetails.slices == null
    ) {
      logNotFoundTrackingProperties(
        "getFlightSelectedTripTrackingProperties",
        "flights"
      );

      return {
        total_stops: 0,
      };
    }

    const totalStops =
      selectedTripDetailsAndFareDetails.tripDetails.slices.reduce(
        (acc, slice) => acc + slice?.stops,
        0
      );

    return {
      total_stops: totalStops,
    };
  }
);
